// 🧻 ورق جدران - نوع لوحة بالفاتورة (بدون إطار، مع تركيب أو بدون).
// السعر = المساحة (م²) × سعر الطباعة للمتر المعتمد بالنظام - نفس رقم واجهة
// "حساب سعر اللوحة" (CanvasCostCalculator.jsx) بالضبط، والأدمن يعدّله من هناك
// (GET/PUT /board-pricing: wallpaperWithInstall / wallpaperWithoutInstall).
// نفس الرقم هو كلفة الطباعة بإكسل الفواتير وحسابات كلفة الفواتير (طلب المدير)
// - نفس المعادلة بالباك اند (artika-backend/controllers/invoiceController.js)
// لقيود الاعتماد.

export const WALLPAPER = "ورق جدران";

// افتراضي فقط لحين ما يوصل السعر المعتمد من السيرفر
export const DEFAULT_WALLPAPER_RATES = { withInstall: 68500, withoutInstall: 46500 };

export const isWallpaper = (item) => item?.panelType === WALLPAPER;

// wallpaperInstall: true (الافتراضي) = مع تركيب
export const wallpaperInstallLabel = (item) =>
  item?.wallpaperInstall === false ? "بدون تركيب" : "مع تركيب";

export const wallpaperRateFor = (item, rates = DEFAULT_WALLPAPER_RATES) =>
  item?.wallpaperInstall === false ? rates.withoutInstall : rates.withInstall;

// الطول والعرض بالسنتيمتر
export const wallpaperAreaM2 = (widthCm, heightCm) =>
  (Number(widthCm || 0) / 100) * (Number(heightCm || 0) / 100);

// كلفة طباعة قطعة ورق جدران وحدة - بالسعر اللي انحفظ ويه البند وقت الفاتورة
// (wallpaperRatePerM2) حتى ما تتغير الفواتير القديمة لو تغيّر السعر بعدين
export const wallpaperPrintCost = (item, widthCm, heightCm) =>
  Math.round(
    wallpaperAreaM2(widthCm, heightCm) *
      (Number(item.wallpaperRatePerM2) || wallpaperRateFor(item))
  );

// الجواب من GET /board-pricing ← أسعار ورق الجدران
export const wallpaperRatesFromPricing = (pricing) => ({
  withInstall: Number(pricing?.wallpaperWithInstall) || DEFAULT_WALLPAPER_RATES.withInstall,
  withoutInstall: Number(pricing?.wallpaperWithoutInstall) || DEFAULT_WALLPAPER_RATES.withoutInstall,
});
